import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService, IDepartmentBO } from '@mapfre-tech/amap3';
import { Observable, of, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import moment from 'moment';
import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  memoryCache: any = {
    "getDeparmentsByOS": {
      "data": null,
      "lastReqDate": null
    }
  }

  className = 'DepartmentService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  /** 
   * Get all departments
   */
  getAllDepartments(showAll = false, cache = true): Observable<IDepartmentBO[]> {
    const params: any = {};
    params.showAll = showAll;
    const cacheKey = "allDepartments"+"_"+showAll.toString();

    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<IDepartmentBO[]>;
    } else {
      const observable = this.http.get<IDepartmentBO[]>(environment.base_URL + "/departments", { params }).pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  /**
   * Get departments by organizational structure and active true/false
   * @param organizationalStructureId 
   * @param showAll 
   * @param cache 
   * @param cacheKey 
   */
  getDepartmentsByOrganizationalStructure(organizationalStructureId: any = null, showAll = false, cache?: any): Observable<IDepartmentBO[]> {
    let cacheKey = "getDeparmentsByOS";
    let params: any = {};

    if (organizationalStructureId) {
      params = {
        organizationalStructureId: organizationalStructureId.join(',')
      }
      const ids = organizationalStructureId.join(',');
      cacheKey = cacheKey+"_"+ids.toString();
    }else{
      cacheKey = cacheKey+"_"+"null";
    }

    params.showAll = showAll;
    cacheKey = cacheKey+"_"+showAll.toString();

    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<IDepartmentBO[]>;
    } else {
      const observable = this.http.get<IDepartmentBO[]>(environment.base_URL + "/departments", { params: params }).pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  /**
   * Create a department
   * @param department 
   */
  add(department: IDepartmentBO) {

    return this.http.post(environment.base_URL + "/departments", department).pipe(tap(() => this.deleteCache()));
  }

  /**
   * Update a department
   * @param department 
   */
  update(department: IDepartmentBO, id: number) {

    return this.http.put(environment.base_URL + `/departments/${id}`, department).pipe(tap(() => this.deleteCache()));
  }

  deleteCache() {
    ["allDepartments", "getDeparmentsByOS"].forEach(key => this.cacheService.deleteCache(key));
  }

  removeById(array: IDepartmentBO[]) {
    array.forEach((element: IDepartmentBO) => {
      delete element.idDepartmentPk;
    });
    return array;
  }

  canUseCache(key: any) {
    const oldDate = _.get(this.memoryCache, `${key}.lastReqDate`);
    let canUse = false;
    if (moment().diff(oldDate, 'minutes') <= 1) {
      canUse = true;
    }
    return canUse;
  }

  updateCacheData(data: any, key: any) {
    _.set(this.memoryCache, `${key}.data`, data);
    _.get(this.memoryCache, `${key}._subject`).next(data);
  }

  updateCacheReq(key: any) {
    const _subject = new Subject<any>();
    const observer = _subject.asObservable();
    _.set(this.memoryCache, key, { observer, _subject, lastReqDate: moment() });
  }
}
